import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { RefreshCcw } from "lucide-react";
import { api } from "@/lib/api";

// Compare quando il server non risponde (down o 5xx, esclusa la manutenzione) e sparisce appena torna a rispondere
export default function ServerDownBanner() {
  const [down, setDown] = useState(false);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    const giu = () => setDown(true);
    const su = () => setDown(false);
    window.addEventListener("wanted-api-down", giu);
    window.addEventListener("wanted-api-ok", su);
    return () => {
      window.removeEventListener("wanted-api-down", giu);
      window.removeEventListener("wanted-api-ok", su);
    };
  }, []);

  const riprova = async () => {
    if (checking) return;
    setChecking(true);
    try {
      await api.get("/maintenance-status", { _skipRefresh: true }); // se risponde, l'intercettore emette api-ok e il banner si chiude
    } catch {
      /* ancora giù: il banner resta */
    } finally {
      setChecking(false);
    }
  };

  return (
    <AnimatePresence>
      {down && (
        <motion.div
          key="server-down"
          initial={{ y: -80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -80, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 28 }}
          className="fixed top-20 left-1/2 -translate-x-1/2 z-[120] w-[calc(100%-1.5rem)] max-w-lg"
          data-testid="server-down-banner"
          role="alert"
        >
          <div className="flex items-center gap-3 rounded-2xl border border-red-500/40 bg-[#141416]/95 px-4 py-3 shadow-[0_10px_40px_rgba(0,0,0,0.6)] backdrop-blur-md">
            <img src="/mascotte.png" alt="" className="w-10 h-12 object-contain shrink-0" aria-hidden />
            <p className="text-xs sm:text-sm text-zinc-200 leading-snug flex-1">
              <span className="font-bold text-red-400">Colpa mia!</span> I server stanno facendo un pisolino. I tuoi dati sono al sicuro: riprova tra poco.
            </p>
            <button
              type="button"
              onClick={riprova}
              disabled={checking}
              data-testid="server-down-retry"
              className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-red-600 hover:bg-red-500 disabled:opacity-50 px-3.5 py-2 text-[11px] font-bold uppercase tracking-wider transition-colors"
            >
              <RefreshCcw className={`h-3.5 w-3.5 ${checking ? "animate-spin" : ""}`} /> Riprova
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
